var React = require('react');

function IcDelete (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m15.918 23.047h3.3203l4.8438 60.898c0.21484 2.793 1.4844 5.3711 3.5352 7.2656 2.0508 1.8945 4.7461 2.9297 7.5586 2.9297h29.629c2.8125 0 5.4883-1.0352 7.5586-2.9492 2.0703-1.9141 3.3203-4.4531 3.5352-7.2461l4.8633-60.898h3.3203c1.8359 0 3.3203-1.4844 3.3203-3.3203 0-1.8359-1.4844-3.3203-3.3203-3.3203h-17.09v-1.3867c0-5.0586-4.082-9.1602-9.1406-9.1602h-15.703c-5.0586 0-9.1406 4.1016-9.1406 9.1602v1.3867h-17.09c-1.8359 0-3.3203 1.4844-3.3203 3.3203 0 1.8359 1.4844 3.3203 3.3203 3.3203zm53.379 60.371c-0.17578 2.3242-2.1484 4.082-4.4727 4.082h-29.629c-2.3242 0-4.2969-1.7773-4.4727-4.082l-4.8242-60.371h48.184zm-29.648-68.398c0-1.4062 1.0938-2.5195 2.5-2.5195h15.703c1.4062 0 2.5 1.1133 2.5 2.5195v1.3867h-20.703z"}));
}

IcDelete.defaultProps = {"width":"100pt","height":"100pt","version":"1.1","viewBox":"0 0 100 100"};

module.exports = IcDelete;

IcDelete.default = IcDelete;
